import { render } from "./StudentPlatformBackground.vue?vue&type=template&id=40452304&scoped=true"
import script from "./StudentPlatformBackground.vue?vue&type=script&lang=js"
export * from "./StudentPlatformBackground.vue?vue&type=script&lang=js"

import "./StudentPlatformBackground.vue?vue&type=style&index=0&id=40452304&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40452304"]])

export default __exports__